export default "__VITE_ASSET__CyRL2y4T__"